export function invertLookupTable<
  A extends string | number | symbol,
  B extends string | number | symbol
>(lookupTable: Record<A, B>): Record<B, A> {
  const inverseLookupTable: Record<B, A> = {} as Record<B, A>
  Object.keys(lookupTable).forEach((key) => {
    const value = lookupTable[key as A]
    if (value !== undefined) {
      inverseLookupTable[value] = key as A
    }
  })

  return inverseLookupTable
}
